import { useState } from 'react'
import { useAuth } from '../hooks/useAuth'
import { supabase } from '../lib/supabase'
import { Button } from '../components/ui/Button'
import { Input } from '../components/ui/Input'
import { LoadingSpinner } from '../components/ui/LoadingSpinner'
import { toast } from 'react-hot-toast'

export function ProfilePage() {
  const { user } = useAuth()
  const [loading, setLoading] = useState(false)
  const [username, setUsername] = useState(user?.username || '')
  const [avatarUrl, setAvatarUrl] = useState(user?.avatar_url || '')

  if (!user) {
    return <LoadingSpinner />
  }

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault()
    setLoading(true)

    try {
      const { error } = await supabase
        .from('users')
        .update({
          username,
          avatar_url: avatarUrl,
        })
        .eq('id', user.id)

      if (error) throw error
      toast.success('Profil mis à jour avec succès')
    } catch (error) {
      toast.error('Erreur lors de la mise à jour du profil')
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="max-w-2xl mx-auto p-4">
      <h1 className="text-2xl font-bold mb-6">Mon Profil</h1>
      
      <div className="bg-white shadow rounded-lg p-6">
        <form onSubmit={handleSubmit} className="space-y-6">
          <Input
            label="Nom d'utilisateur"
            id="username"
            type="text"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            required
          />

          <Input
            label="URL de l'avatar"
            id="avatarUrl"
            type="url"
            value={avatarUrl}
            onChange={(e) => setAvatarUrl(e.target.value)}
          />

          <div className="flex items-center space-x-4">
            <img
              src={avatarUrl || `https://ui-avatars.com/api/?name=${username}`}
              alt="Avatar"
              className="h-16 w-16 rounded-full"
            />
          </div>

          <div className="pt-4">
            <Button
              type="submit"
              isLoading={loading}
              loadingText="Mise à jour..."
            >
              Mettre à jour le profil
            </Button>
          </div>
        </form>

        <div className="mt-6 border-t pt-6">
          <h2 className="text-lg font-semibold mb-4">Statistiques</h2>
          <div className="grid grid-cols-2 gap-4">
            <div className="bg-gray-50 p-4 rounded">
              <p className="text-sm text-gray-500">Points totaux</p>
              <p className="text-2xl font-bold">{user.points}</p>
            </div>
            <div className="bg-gray-50 p-4 rounded">
              <p className="text-sm text-gray-500">Membre depuis</p>
              <p className="text-2xl font-bold">
                {new Date(user.created_at).toLocaleDateString()}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}